import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getCategoryDropDown,
  getTopicDropDown,
  imageUpload,
} from "../../../features/slices/liveStream";
import { useSelector } from "react-redux";
import Select from "react-select";
import ISO6391 from "iso-639-1";
import upploadImage from "../../../assets/images/upload-video.png";
import help from "../../../assets/images/help.png";
import infoCircle from "../../../assets/images/info-circle.png";
import {
  addCourse,
  updateCourse,
} from "../../../features/slices/coursesManagement";
import { toastService } from "../../../utils/toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import {
  ListProperties,
  Alignment,
  List,
  Image,
  AutoImage,
  ImageInsert,
  ImageResize, // Add this
  ImageToolbar, // Add this
  ImageStyle, // Add this
  ImageCaption,
  SimpleUploadAdapter,
  Base64UploadAdapter,
} from "ckeditor5";

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
} from "ckeditor5";
import LoaderForImage from "../../LoaderForImage";
import QuillEditor from "../../QuillEditor";
import VideoPlayer from "../../VideoPlayer";
const initialValue = {
  categoryId: "",
  topicId: "",
  title: "",
  courseType: "",
  whatWillYouLearn: "",
  whoShouldEnroll: "",
  whyTakeThisCourse: "",
  coursePrerequisites: "",
  teacherName: "",
  teacherProfilePic: "",
  aboutTeacher: "",
  courseMedia: { video: "", courseLanguage: "English" },
  thumbnail: "",
  price: "",
  discount: 0,
  id: "",
  supportingDocuments: [{ title: "", url: "", order: 0 }],
};
const EditCourseDetail = () => {
  const [iState, setUpdateState] = useState(initialValue);
  const [count, setCount] = useState([{ video: "", courseLanguage: "" }]);
  const [imageLoader, setImageLoader] = useState({
    video: false,
    image: false,
    document: false,
  });
  const [errors, setErrors] = useState({});
  const {
    categoryId,
    topicId,
    title,
    courseType,
    whatWillYouLearn,
    whoShouldEnroll,
    whyTakeThisCourse,
    coursePrerequisites,
    teacherName,
    teacherProfilePic,
    aboutTeacher,
    courseMedia,
    thumbnail,
    price,
    discount,
    id,
    supportingDocuments,
  } = iState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      // Extracting courseMedia data properly
      const courseMediaData =
        state?.courseMedia?.length > 0
          ? {
              video: state?.courseMedia[0]?.video || "",
              courseLanguage:
                state?.courseMedia[0]?.courseLanguage || "English",
            }
          : { video: "", courseLanguage: "English" };

      // Setting updateState with the correct structure
      setUpdateState({
        categoryId: state?.categoryId,
        topicId: state?.topicId,
        title: state?.title,
        courseType: state?.courseType,
        courseMedia: courseMediaData, // Handling courseMedia properly
        whatWillYouLearn: state?.whatWillYouLearn,
        whoShouldEnroll: state?.whoShouldEnroll,
        whyTakeThisCourse: state?.whyTakeThisCourse,
        coursePrerequisites: state?.coursePrerequisites,
        teacherName: state?.teacherName,
        teacherProfilePic: state?.teacherProfilePic,
        aboutTeacher: state?.aboutTeacher,
        thumbnail: state?.thumbnail,
        price: state?.price,
        discount: state?.discount,
        id: state?._id,
        supportingDocuments:
          state?.supportingDocuments?.length > 0
            ? state?.supportingDocuments?.map((doc, index) => ({
                title: doc?.title || "",
                url: doc?.url || "",
                order: index,
                _id: doc?._id,
              }))
            : [{ title: "", url: "", order: 0 }],
      });

      // Dispatch action to get topic dropdown data
      dispatch(getTopicDropDown({ categoryId: state?.categoryId })).then(
        (data) => {
          console.log({ data });
        }
      );
    } else {
      // If state is not available, navigate to course management
      navigate("/courseManagement");
    }

    // Set count for courseMedia
    setCount(state?.courseMedia?.length || 0); // Handling courseMedia array count properly
  }, [state]);

  const handleChangeEditor = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const { categoryDropDownData, loading, topicDropDowndata } = useSelector(
    (state) => state.liveStream
  );
  const languageOptions = ISO6391.getAllCodes().map((code) => ({
    value: code,
    label: ISO6391.getName(code),
  }));
  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleQuillChange = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" })); // Reset error for the specific field
    setUpdateState((prev) => ({ ...prev, [name]: value })); // Dynamically update the corresponding state field
  };
  const handleLanguageChange = (selected) => {
    const langData = selected?.map((val) => val?.label) || [];

    setUpdateState((prev) => ({
      ...prev,
      courseLanguage: langData,
    }));
  };
  useEffect(() => {
    dispatch(getCategoryDropDown()).then((data) => {
      console.log({ data });
    });
  }, []);
  const handleChangeCategory = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    setUpdateState({ ...iState, [e.target.name]: e.target.value });
    dispatch(getTopicDropDown({ categoryId: e.target.value })).then((data) => {
      console.log({ data });
    });
  };
  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          setUpdateState({
            ...iState,
            [e.target.name]: res?.payload?.url,
          });
        }
      });
    }
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!title?.trim()) {
      formErrors.title = "title is required.";
      isValid = false;
    }

    if (!categoryId?.trim()) {
      formErrors.categoryId = "category is required.";
      isValid = false;
    }
    if (!topicId?.trim()) {
      formErrors.topicId = "topic is required.";
      isValid = false;
    }

    if (!courseType?.trim()) {
      formErrors.courseType = "course type is required.";
      isValid = false;
    }

    if (!whatWillYouLearn?.trim()) {
      formErrors.whatWillYouLearn = "whatWillYouLearn is required.";
      isValid = false;
    }
    if (!whoShouldEnroll?.trim()) {
      formErrors.whoShouldEnroll = "who Should Enroll is required.";
      isValid = false;
    }
    if (!whyTakeThisCourse?.trim()) {
      formErrors.whyTakeThisCourse = "why Take This Course is required.";
      isValid = false;
    }
    if (!coursePrerequisites?.trim()) {
      formErrors.coursePrerequisites = "course prerequisites is required.";
      isValid = false;
    }
    if (!teacherName?.trim()) {
      formErrors.teacherName = "teacher name is required.";
      isValid = false;
    }
    if (!aboutTeacher?.trim()) {
      formErrors.aboutTeacher = "about teacher is required.";
      isValid = false;
    }
    if (!teacherProfilePic?.trim()) {
      formErrors.teacherProfilePic = "teacher profile pic is required.";
      isValid = false;
    }
    if (!thumbnail?.trim()) {
      formErrors.thumbnail = "thumbnail is required.";
      isValid = false;
    }
    if (!courseMedia?.video?.trim()) {
      formErrors.courseImage = "course image is required.";
      isValid = false;
    }
    if (courseType !== "FREE" && !price?.trim()) {
      formErrors.price = "price is required.";
      isValid = false;
    }
    if (courseType !== "FREE" && discount == 0) {
      formErrors.discount = "discount is required.";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    if (validateForm()) {
      const payload = {
        ...iState,
        supportingDocuments: (iState.supportingDocuments || [])
          .filter((doc) => doc?.title?.trim() || doc?.url)
          .map((doc, index) => ({
            title: doc?.title?.trim() || "",
            url: doc?.url || "",
            order: index,
          })),
      };
      dispatch(updateCourse(payload)).then((res) => {
        if (res?.payload?.code == 200) {
          toastService.success("Course edited successfully");
          setUpdateState(iState);
          navigate("/courses");
        } else {
          toastService.success("Course edited failed");
        }
      });
    }
  };
  const handleCoursesMedia = (value) => {
    setErrors((prev) => ({
      ...prev,
      video: "",
    }));
    const file = value;
    if (file) {
      setImageLoader((prev) => ({
        ...prev,
        video: true,
      }));
      const formData = new FormData();
      formData.append("fileName", file);

      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Successfully uploaded");

          setUpdateState((prev) => ({
            ...prev,
            courseMedia: {
              ...prev.courseMedia, // Keep existing properties
              video: res?.payload?.url, // Update the video property
            },
          }));
          setImageLoader((prev) => ({
            ...prev,
            video: false,
          }));
        } else {
          toastService.error("Failed to upload");
        }
      });
    }
  };
  const handleDisCard = () => {
    setUpdateState(initialValue);
    setErrors({});
  };
  const handleChangeEmbeddedVideo = (e) => {
    setErrors((prev) => ({
      ...prev,
      video: "",
    }));
    setUpdateState((prev) => ({
      ...prev,
      courseMedia: {
        ...prev.courseMedia,
        video: e?.target?.value,
      },
    }));
  };
  const handleAddSupportingDocument = () => {
    setErrors((prev) => ({ ...prev, supportingDocuments: "" }));
    setUpdateState((prev) => ({
      ...prev,
      supportingDocuments: [
        ...(prev.supportingDocuments || []),
        {
          title: "",
          url: "",
          order: (prev.supportingDocuments || []).length,
        },
      ],
    }));
  };

  const handleRemoveSupportingDocument = (index) => {
    setUpdateState((prev) => ({
      ...prev,
      supportingDocuments: (prev.supportingDocuments || [])
        .filter((_, i) => i !== index)
        .map((doc, idx) => ({ ...doc, order: idx })),
    }));
  };

  const handleSupportingDocumentTitle = (index, value) => {
    setErrors((prev) => ({ ...prev, supportingDocuments: "" }));
    setUpdateState((prev) => ({
      ...prev,
      supportingDocuments: (prev.supportingDocuments || []).map((doc, i) =>
        i === index ? { ...doc, title: value } : doc
      ),
    }));
  };

  const handleSupportingDocumentUpload = (index, file) => {
    if (!file) return;
    setErrors((prev) => ({ ...prev, supportingDocuments: "" }));
    setImageLoader((prev) => ({
      ...prev,
      document: true,
    }));
    const formData = new FormData();
    formData.append("fileName", file);
    dispatch(imageUpload(formData)).then((res) => {
      if (res?.payload?.code === 200) {
        toastService.success("Document uploaded successfully");
        setUpdateState((prev) => ({
          ...prev,
          supportingDocuments: (prev.supportingDocuments || []).map((doc, i) =>
            i === index ? { ...doc, url: res?.payload?.url } : doc
          ),
        }));
      } else {
        toastService.error("Failed to upload document");
      }
      setImageLoader((prev) => ({
        ...prev,
        document: false,
      }));
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Edit Course Details</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Name/ Title of Course</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name/title of course"
                onChange={handleChange}
                name="title"
                value={title}
              />
              {errors.title && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.title}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Category</label>
              <select
                className="form-control"
                name="categoryId"
                onChange={handleChangeCategory}
              >
                <option>select</option>
                {categoryDropDownData?.result?.map((res) => {
                  return (
                    <option value={res?._id} selected={res?._id == categoryId}>
                      {res?.categoryName}
                    </option>
                  );
                })}
              </select>
              {errors.categoryId && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.categoryId}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Topic</label>
              <select
                className="form-control"
                name="topicId"
                onChange={handleChange}
              >
                <option>select</option>
                {topicDropDowndata &&
                  topicDropDowndata?.result?.map((res) => {
                    return (
                      <option value={res?._id} selected={res?._id == topicId}>
                        {res?.topicName}
                      </option>
                    );
                  })}
              </select>
              {errors.topicId && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.topicId}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Course Type</label>
              <select
                className="form-control"
                name="courseType"
                onChange={handleChange}
                value={courseType}
              >
                <option>select</option>
                <option value={"FREE"}> FREE</option>
                <option value={"PAID"}>PAID</option>
              </select>
              {errors.courseType && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.courseType}
                </p>
              )}
            </div>
          </div>
          <div className="form-group">
            <label>Embedded Video</label>
            <input
              type="text"
              className="form-control"
              placeholder="Embedded Video Url"
              onChange={handleChangeEmbeddedVideo}
              name="embeddedVideo"
              value={courseMedia?.video}
            />
            {/* {errors.courseMedia.video && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.courseMedia.video}
                </p>
              )} */}
          </div>
          <div>
            <div className="TitleBox Border">
              <h4 className="Title">Course &amp; Video</h4>
            </div>

            <div className="CommonForm" style={{ display: "flex" }}>
              {imageLoader.video ? (
                <LoaderForImage />
              ) : (
                <div>
                  <div
                    className="UploadBox Image"
                    style={{ position: "relative", zIndex: 0 }}
                  >
                    {!imageLoader ? (
                      <LoaderForImage />
                    ) : (
                      <span>
                        {!courseMedia.video && (
                          <img src={upploadImage} alt="Upload" />
                        )}{" "}
                        {/* Default upload image */}
                        {courseMedia.video && (
                          <>
                            {/* <video
                              src={courseMedia.video} // Create a URL for the uploaded video file
                              controls
                              style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                mixBlendMode: "darken",
                                zIndex: 1, // Make sure the video is above the input
                              }}
                            /> */}
                            <VideoPlayer
                              url={courseMedia?.video}
                              divHeight="110px"
                              divStyle={{
                                height: "100%",
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                zIndex: 1,
                              }}
                            />
                            {/* Edit icon to update the video */}
                            <i
                              className="fas fa-edit"
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                color: "#fff",
                                background: "rgba(0, 0, 0, 0.6)",
                                borderRadius: "50%",
                                padding: "5px",
                                zIndex: 2, // Place icon above the video
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                document.querySelector(`#file-input`).click()
                              } // Trigger file input on icon click
                            />
                          </>
                        )}
                      </span>
                    )}

                    {/* File input field */}
                    <input
                      id={`file-input`} // Unique ID for each input
                      type="file"
                      name="video"
                      accept=".mp4" // Accept only video files
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        opacity: 0, // Hide input when a video is present
                        zIndex: courseMedia.video ? 0 : 2,
                        cursor: "pointer",
                      }}
                      onChange={(e) => handleCoursesMedia(e.target.files[0])} // Pass the actual file to handleCourseMedia
                    />

                    {/* Text to prompt upload if no video is uploaded */}
                    {!courseMedia.video && (
                      <p>
                        <label>Click to upload video</label> or <br /> drag
                        &amp; drop
                      </p>
                    )}
                  </div>
                  {errors.video && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.video}
                    </p>
                  )}
                </div>
              )}

              {imageLoader.image ? (
                <LoaderForImage />
              ) : (
                <div>
                  <div
                    className="UploadBox Image"
                    style={{
                      position: "relative",
                      zIndex: 0,
                    }}
                  >
                    <span>
                      {!thumbnail && <img src={upploadImage} />}
                      {thumbnail && (
                        <>
                          <img
                            src={thumbnail}
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "0",
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              mixBlendMode: "darken",
                            }}
                          />
                          <i
                            className="fas fa-edit"
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              color: "#fff",
                              background: "rgba(0, 0, 0, 0.6)",
                              borderRadius: "50%",
                              padding: "5px",
                              zIndex: 2, // Place icon above the video
                              cursor: "pointer",
                            }}
                            // Trigger file input on icon click
                          />
                        </>
                      )}
                    </span>
                    <input
                      type="file"
                      accept=".png,.jpg,.jpeg"
                      name="thumbnail"
                      onChange={handleImage}
                    />
                    {!thumbnail && (
                      <p>
                        <label>Upload thumbnail Image</label> <br /> or drag
                        &amp; drop
                      </p>
                    )}
                  </div>
                  {errors.thumbnail && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.thumbnail}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* {count?.map((res, index) => {
            return (
              <div key={index}>
                <div className="form-group">
                  <label style={{ fontWeight: "500" }}>Course Language</label>
                  <Select
                    name="courseLanguage"
                    options={languageOptions}
                    placeholder="Select languages..."
                    value={languageOptions.find(
                      (option) => option.label === res.courseLanguage
                    )} // Find the corresponding option object by its label
                    onChange={(option) =>
                      handleCourseMedia(index, "courseLanguage", option.label)
                    } // Handle change
                  />
                  {errors.courseLanguage && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.courseLanguage}
                    </p>
                  )}
                </div>

                <div className="TitleBox Border">
                  <h4 className="Title">Course &amp; Video</h4>
                </div>

                <div className="CommonForm">
                  <div
                    className="UploadBox Image"
                    style={{ position: "relative" }}
                  >
                    <span>
                      {!res.video && <img src={upploadImage} alt="Upload" />}
                      {res.video && (
                        <video
                          src={res.video}
                          controls
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mixBlendMode: "darken",
                          }}
                        />
                      )}
                    </span>
                    <input
                      type="file"
                      name="video"
                      onChange={(e) =>
                        handleCourseMedia(
                          index,
                          "video",
                          URL.createObjectURL(e.target.files[0])
                        )
                      }
                    />
                    <p>
                      <label>Click to upload</label> or <br /> drag &amp; drop
                    </p>
                  </div>
                  {errors.video && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.video}
                    </p>
                  )}
                  {index == 0 && (
                    <>
                      <div
                        className="UploadBox Image"
                        style={{
                          position: "relative",
                        }}
                      >
                        <span>
                          {!thumbnail && <img src={upploadImage} />}
                          {thumbnail && (
                            <img
                              src={thumbnail}
                              style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                mixBlendMode: "darken",
                              }}
                            />
                          )}
                        </span>
                        <input
                          type="file"
                          name="thumbnail"
                          onChange={handleImage}
                        />
                        <p>
                          <label>Upload Image</label> <br /> or drag &amp; drop
                        </p>
                      </div>
                      {errors.thumbnail && (
                        <p className="d-flex justify-content-start text-danger mt-2 ">
                          {errors.thumbnail}
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })} */}
          {/* <button
            className="Button mb-2"
            onClick={handleAddOtherLanguageVideos}
          >
            Add other language videos
          </button> */}
          <div className="TitleBox Border">
            <h4 className="Title">Add Course Description</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>What will you learn</label>
              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    // "toggleImageCaption",
                    // "imageTextAlternative",
                    // "ckboxImageEdit",
                    // "insertImage",
                    // "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    // Image,
                    // AutoImage,
                    // ImageInsert,
                    // ImageResize, // Add this
                    // ImageToolbar, // Add this
                    // ImageStyle, // Add this
                    // ImageCaption,
                    // SimpleUploadAdapter,
                    // Base64UploadAdapter, // Add this
                  ],
                  // image: {
                  //   toolbar: [
                  //     "imageTextAlternative",
                  //     "toggleImageCaption",
                  //     "imageStyle:inline",
                  //     "imageStyle:block",
                  //     "imageStyle:side",
                  //   ],
                  // },
                  // simpleUpload: {
                  //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  // },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="whatWillYouLearn"
                data={whatWillYouLearn}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log({ event, editor, data })
                  handleChangeEditor("whatWillYouLearn", data);
                }}
              /> */}
              {/* <input
                type="text"
                className="form-control"
                placeholder="Enter Description"
                name="whatWillYouLearn"
                value={whatWillYouLearn}
                onChange={handleChange}
              /> */}
              {/* {errors.whatWillYouLearn && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.whatWillYouLearn}
                </p>
              )} */}
              <QuillEditor
                name="whatWillYouLearn"
                value={whatWillYouLearn}
                onChange={handleQuillChange}
                error={errors.whatWillYouLearn}
                // Optional custom height
              />
            </div>
            <div className="form-group">
              <label>Why Take This Course</label>
              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    // "toggleImageCaption",
                    // "imageTextAlternative",
                    // "ckboxImageEdit",
                    // "insertImage",
                    // "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    // Image,
                    // AutoImage,
                    // ImageInsert,
                    // ImageResize, // Add this
                    // ImageToolbar, // Add this
                    // ImageStyle, // Add this
                    // ImageCaption,
                    // SimpleUploadAdapter,
                    // Base64UploadAdapter, // Add this
                  ],
                  // image: {
                  //   toolbar: [
                  //     "imageTextAlternative",
                  //     "toggleImageCaption",
                  //     "imageStyle:inline",
                  //     "imageStyle:block",
                  //     "imageStyle:side",
                  //   ],
                  // },
                  // simpleUpload: {
                  //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  // },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="whyTakeThisCourse"
                data={whyTakeThisCourse}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log({ event, editor, data })
                  handleChangeEditor("whyTakeThisCourse", data);
                }}
              />

              {errors.whyTakeThisCourse && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.whyTakeThisCourse}
                </p>
              )} */}
              <QuillEditor
                name="whyTakeThisCourse"
                value={whyTakeThisCourse}
                onChange={handleQuillChange}
                error={errors.whyTakeThisCourse}
                // Optional custom height
              />
            </div>
            <div className="form-group">
              <label>Who Should Enroll</label>
              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    // "toggleImageCaption",
                    // "imageTextAlternative",
                    // "ckboxImageEdit",
                    // "insertImage",
                    // "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    // Image,
                    // AutoImage,
                    // ImageInsert,
                    // ImageResize, // Add this
                    // ImageToolbar, // Add this
                    // ImageStyle, // Add this
                    // ImageCaption,
                    // SimpleUploadAdapter,
                    // Base64UploadAdapter, // Add this
                  ],
                  // image: {
                  //   toolbar: [
                  //     "imageTextAlternative",
                  //     "toggleImageCaption",
                  //     "imageStyle:inline",
                  //     "imageStyle:block",
                  //     "imageStyle:side",
                  //   ],
                  // },
                  // simpleUpload: {
                  //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  // },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="whoShouldEnroll"
                data={whoShouldEnroll}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log({ event, editor, data })
                  handleChangeEditor("whoShouldEnroll", data);
                }}
              />

              {errors.whoShouldEnroll && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.whoShouldEnroll}
                </p>
              )} */}
              <QuillEditor
                name="whoShouldEnroll"
                value={whoShouldEnroll}
                onChange={handleQuillChange}
                error={errors.whoShouldEnroll}
                // Optional custom height
              />
            </div>
            <div className="form-group">
              <label>Course Prerequisites</label>
              <QuillEditor
                name="coursePrerequisites"
                value={coursePrerequisites}
                onChange={handleQuillChange}
                error={errors.coursePrerequisites}
                // Optional custom height
              />
              {/* {errors.coursePrerequisites && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.coursePrerequisites}
                </p>
              )} */}
            </div>
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Add Teacher Details</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Teacher Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter teacher name"
                name="teacherName"
                value={teacherName}
                onChange={handleChange}
              />
              {errors.teacherName && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.teacherName}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>About Teacher</label>
              <QuillEditor
                name="aboutTeacher"
                value={aboutTeacher}
                onChange={handleQuillChange}
                error={errors.aboutTeacher}
                // Optional custom height
              />
              {/* {errors.aboutTeacher && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.aboutTeacher}
                </p>
              )} */}
            </div>
            <div
              className="UploadBox Image"
              style={{
                position: "relative",
              }}
            >
              <span
                style={{
                  zIndex: "99",
                }}
              >
                {!teacherProfilePic && <img src={upploadImage} />}
                {teacherProfilePic && (
                  <>
                    <img
                      src={teacherProfilePic}
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        mixBlendMode: "darken",
                      }}
                    />
                    <i
                      className="fas fa-edit"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        color: "#fff",
                        background: "rgba(0, 0, 0, 0.6)",
                        borderRadius: "50%",
                        padding: "5px",
                        zIndex: 2, // Place icon above the video
                        cursor: "pointer",
                      }}
                      // Trigger file input on icon click
                    />
                  </>
                )}
              </span>
              <input
                type="file"
                accept=".png,.jpg,.jpeg"
                name="teacherProfilePic"
                onChange={handleImage}
              />
              {!teacherProfilePic && (
                <p>
                  <label>Click to upload</label> or <br /> drag &amp; drop
                </p>
              )}
            </div>
            {errors.teacherProfilePic && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.teacherProfilePic}
              </p>
            )}
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Supporting Documents</h4>
          </div>
          <div className="CommonForm">
            {(supportingDocuments || []).map((doc, index) => (
              <div className="row" key={doc?._id || `supporting-document-${index}`}>
                <div className="col-lg-5">
                  <div className="form-group">
                    <label>Document Title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter document title"
                      value={doc?.title || ""}
                      onChange={(e) =>
                        handleSupportingDocumentTitle(index, e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="form-group">
                    <label>Upload Document</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
                      onChange={(e) =>
                        handleSupportingDocumentUpload(index, e.target.files[0])
                      }
                    />
                    {doc?.url && (
                      <small className="text-success d-block mt-1">
                        Uploaded
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 d-flex align-items-center">
                  {index === (supportingDocuments || []).length - 1 ? (
                    <button
                      type="button"
                      className="Button w-100"
                      onClick={handleAddSupportingDocument}
                    >
                      Add Document
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="Button Discard w-100"
                      onClick={() => handleRemoveSupportingDocument(index)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            ))}
            {imageLoader.document && <LoaderForImage />}
            {errors.supportingDocuments && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.supportingDocuments}
              </p>
            )}
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">
              Pricing{" "}
              <span>
                <img src={help} />
              </span>
            </h4>
          </div>
          <div className="CommonForm">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Best Price *</label>
                  <div className="NewInputBox">
                    <span>$</span>
                    <input
                      type="text"
                      className="form-control"
                      name="price"
                      value={price}
                      onChange={handleChange}
                      disabled={courseType == "FREE"}
                    />
                  </div>
                  {errors.price && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.price}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>
                    Discount Percent <img src={infoCircle} />
                  </label>
                  <div className="NewInputBox">
                    <span>%</span>
                    <select
                      className="form-control"
                      name="discount"
                      value={discount}
                      onChange={handleChange}
                      disabled={courseType == "FREE"}
                    >
                      <option>--select--</option>
                      <option value={"10%"}>10%</option>
                      <option value={"20%"}>20%</option>
                      <option value={"30%"}>30%</option>
                    </select>
                  </div>
                  {errors.discount && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.discount}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <button className="Button Discard">Discard</button>
          {/* <button class="Button">Save & Next</button> */}
          <button className="Button" onClick={handleSubmit}>
            Save{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCourseDetail;
